import { render, staticRenderFns } from "./biRecord.vue?vue&type=template&id=5f954e45&scoped=true&"
import script from "./biRecord.vue?vue&type=script&lang=js&"
export * from "./biRecord.vue?vue&type=script&lang=js&"
import style0 from "./biRecord.vue?vue&type=style&index=0&id=5f954e45&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f954e45",
  null
  
)

export default component.exports